import { FunctionComponent } from 'react';
import { CPLinkExpiredModal } from 'widgets/auth/createPassword/LinkExpiredModal';

export const CreatePasswordLinkExpired: FunctionComponent = () => {
	return <CPLinkExpiredModal />;
};
